import React, {useEffect, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import {Link, useNavigate} from 'react-router-dom';
import {HeaderOPT, HeaderOPTAdditionally} from "./HeaderOPT";
import DateRangeFilter from "../../../../filter/DateRangeFilter";
import Box from "@mui/material/Box";
import CellOPTm from "./CellOPTm";
import ButtonCreate from "../../../../button/ButtonCreate";
import {Switch, Tooltip} from "@mui/material";
import {handlerExport} from "../../../../../../pages/common/settings/handlerExport";
import MaterialEstimateUnitService
    from "../../../../../../API/orders/estimate/organization/MaterialEstimateUnitService";
import MenuItem from "@mui/material/MenuItem";
import EstimateService from "../../../../../../API/orders/estimate/organization/EstimateService";
import FormControlLabel from "@mui/material/FormControlLabel";

const OrderProductionTable = ({
                                  additionallyColumn,
                                  data,
                                  setData,
                                  customerList,
                                  nameList,
                                  planningList,
                                  isColumnPlan,
                                  isIssue,
                                  isPlan,
                                  hideCustomer,
                                  tableOptions,
                                  tableOptionsHandle,
                                  handleModalAlert,
                                  globalFilter,
                                  handleSearchQuery,
                                  filteredData,
                                  columnsFilter,
                                  shipped,
                                  getProductionData,
                                  refHide
                              }) => {
    const navigate = useNavigate();
    const [showColumnFilters, setShowColumnFilters] = useState(false)

    const handleShowColumnFilters = () => {
        setShowColumnFilters(!showColumnFilters)
        if (showColumnFilters) {
            handleSearchQuery([], data, null, true)
        }
    }
    const redirectPlans = () => {
        navigate('/organization/plans');
    };

    const modelsList = useMemo(() => {
        const set = new Set();
        for (const row of data || []) {
            for (const module of row.estimate?.modules || []) {
                if (module.originalName) {
                    set.add(module.originalName);
                }
            }
        }
        return Array.from(set);
    }, [data]);

    const columns = useMemo(() => {
        const baseColumns = [
            {
                id: 'number',
                header: 'Номер заказа',
                accessorKey: 'number',
                filterFn: 'contains',
                minSize: 150,
                grow: true,
                Header: ({column}) => <HeaderOPT column={column} height={100}></HeaderOPT>,
                Cell: ({cell, row}) => {
                    return refHide ? <li key={cell.getValue()}>{cell.getValue()}</li> :
                        isIssue ?
                            <li key={cell.getValue()}>
                                <Link
                                    to={'/organization/issuance-piece-materials/' + row.original.id + '/' + encodeURIComponent(cell.getValue())}>{cell.getValue()}</Link>
                            </li> :
                            <li key={cell.getValue()}>
                                <Link
                                    to={'/organization/technical-map/' + row.original.id + '/' + encodeURIComponent(cell.getValue())}>{cell.getValue()}</Link>
                            </li>
                }
            },
            {
                id: 'header',
                header: 'Наименование',
                accessorKey: 'header',
                filterVariant: 'multi-select',
                filterSelectOptions: nameList,
                enableGrouping: true,
                minSize: 200,
                grow: true,
                Header: ({column}) => <HeaderOPT column={column} height={100}></HeaderOPT>,
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по наименование',
                    sx: {
                        width: '200px',
                    },
                }
            },
            /* {
                 id: 'attributes',
                 header: 'Атрибуты',
                 accessorKey: 'attributes',
                 filterVariant: 'multi-select',
                 filterSelectOptions: attributeList,
                 filterFn: (row, id, filterValue) => {
                     return OrderUtil.checkStatus(row.getValue(id), filterValue)
                 },
                 minSize: 20,
                 Cell: ({cell}) => (<div>{AttributeUtil.convertAttributes(cell.getValue())}</div>),
                 Header: ({column}) => <HeaderOPT column={column} height={400}></HeaderOPT>,

             },*/
            {
                accessorFn: (row) => {
                    if (row.dateOfPlannedProduction === null) {
                    } else {
                        return new Date(row.dateOfPlannedProduction)
                    }
                },
                id: 'dateOfPlannedProduction',
                grow: true,
                header: 'Плановая дата произодства',
                sortingFn: 'datetime',
                minSize: 200,
                Cell: ({cell}) => {
                    if (cell.getValue() !== undefined) {
                        return cell.getValue().toLocaleDateString();
                    }
                },
                Header: ({column}) => <HeaderOPT column={column} height={100}></HeaderOPT>,
                Filter: ({column}) => <DateRangeFilter
                    column={column}
                />,
            },
            {
                header: 'id',
                accessorKey: 'id',
                enableHiding: false,
                enableColumnActions: false,
                enableGrouping: false,
                enableColumnFilter: false,
            },
        ];
        if (!isPlan) {
            baseColumns.splice(20, 0, {
                id: "packagingPercentage",
                header: "Фурнитура (собрано)",
                accessorKey: 'estimate.packagingPercentage',
                maxSize: 34,
                size: 34,
                minSize: 1,
                grow: false,
                enableColumnActions: false,
                enableGrouping: false,
                enableColumnFilter: false,
                enableSorting: false,
                Header: ({column}) => <HeaderOPTAdditionally
                    column={column} height={100}></HeaderOPTAdditionally>,
                Cell: ({row, cell}) => <CellOPTm
                    row={row}
                    cell2={cell}
                    cellEstimate={cell.getValue()}
                >
                </CellOPTm>,
            })
            baseColumns.splice(20, 0, {
                id: "issuePercentage",
                header: "Фурнитура (выдано)",
                accessorKey: 'estimate.issuePercentage',
                maxSize: 34,
                size: 34,
                minSize: 1,
                grow: false,
                enableColumnActions: false,
                enableGrouping: false,
                enableColumnFilter: false,
                enableSorting: false,
                Header: ({column}) => <HeaderOPTAdditionally
                    column={column} height={100}></HeaderOPTAdditionally>,
                Cell: ({row, cell}) => <CellOPTm
                    row={row}
                    cell2={cell}
                    cellEstimate={cell.getValue()}
                >
                </CellOPTm>,
            })
        }

        {
            additionallyColumn.map((statusKey) => (
                baseColumns.splice(5, 0, {
                    id: statusKey.name,
                    header: statusKey.name,
                    accessorKey: 'id',
                    maxSize: 34,
                    size: 34,
                    minSize: 1,
                    grow: false,
                    enableColumnActions: false,
                    enableGrouping: false,
                    enableColumnFilter: false,
                    enableSorting: false,
                    Header: ({column}) => <HeaderOPTAdditionally
                        column={column} height={100}></HeaderOPTAdditionally>,
                    Cell: ({row, cell}) => <CellOPTm
                        row={row}
                        cell2={cell}
                    >
                    </CellOPTm>,
                })
            ))
        }

        if (!hideCustomer) {
            baseColumns.splice(2, 0, {
                id: 'customerName',
                header: 'Заказчик',
                accessorKey: 'customerName',
                enableStickyHeader: true,
                enableStickyFooter: true,
                enableGrouping: true,
                filterVariant: 'multi-select',
                filterSelectOptions: customerList,
                minSize: 130,
                grow: true,
                Header: ({column}) => <HeaderOPT column={column} height={100}></HeaderOPT>,
                Cell: ({row, cell}) => <Tooltip arrow placement="bottom"
                                                title={row.original.customerName}><Box
                    sx={{
                        width: "130px",
                        overflow: "clip",
                        textOverflow: "ellipsis"
                    }}>{row.original.customerName}</Box>
                </Tooltip>
            });
        }

        if (isColumnPlan) {
            baseColumns.splice(5, 0, {
                id: 'state',
                header: 'План',
                accessorKey: 'state',
                filterVariant: 'multi-select',
                filterSelectOptions: planningList,
                minSize: 50,
                maxSize: 6,
                Header: ({column}) => <HeaderOPT column={column} height={100}></HeaderOPT>,
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по план',
                    sx: {
                        width: '130px',
                    },
                }
            });
            baseColumns.splice(6, 0, {
                id: 'models',
                header: 'Модели',
                accessorFn: (row) => (row.estimate?.modules || [])
                    .map((module) => module.originalName)
                    .filter(Boolean)
                    .join(', '),
                filterVariant: 'multi-select',
                filterSelectOptions: modelsList,
                minSize: 50,
                maxSize: 6,
                Header: ({column}) => <HeaderOPT column={column} height={100}></HeaderOPT>,
                Cell: ({cell}) => {
                    const value = cell.getValue();
                    if (!value) {
                        return null;
                    }
                    return (
                        <Tooltip arrow placement="bottom" title={value}>
                            <Box
                                sx={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {value}
                            </Box>
                        </Tooltip>
                    );
                },
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по модели',
                    sx: {
                        width: '130px',
                    },
                }
            });
        }

        return baseColumns;

    }, [data, setData, isColumnPlan, additionallyColumn, filteredData, modelsList]);

    const handleSubmitExport = (row) => {
        handlerExport(() => MaterialEstimateUnitService.export(row.id, row.number), handleModalAlert)
    }
    const handleSetWithoutAccessor = (currentRow) => {
        EstimateService.setWithoutAccessor(currentRow.id)
            .then(function () {
                if (isIssue) {
                    const newData = data.map(el => el.id === currentRow.id ? {
                        ...el, estimate: {
                            ...el.estimate, "packagingPercentage": null,
                            "issuePercentage": null
                        }
                    } : el)
                    setData(newData)
                    handleSearchQuery(globalFilter, newData)
                }
                handleModalAlert("Установлено", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
    }
    const menuItem = (isIssue || isPlan) ? [
        {type: "download", text: "Экспорт", handler: handleSubmitExport},
        {type: "setWithoutAccessor", text: "Установить без фурнитуры", handler: handleSetWithoutAccessor}
    ] : [{type: "download", text: "Экспорт", handler: handleSubmitExport}]

    const handleChange = () => {
        getProductionData(globalFilter, null, !shipped)
        const itemName = isIssue ? "isIssueProductionShipped" : "isProductionShipped"
        localStorage.setItem(itemName, JSON.stringify(!shipped))
    }

    // Вертикальные колонки работ идут без padding; +1 если есть «Модели» после «План»
    const zeroPaddingFromColumn = (isIssue ? 6 : 5) + (isColumnPlan ? 1 : 0)
    const minTableWidth = (isPlan ? 600 : isIssue ? 830 : 765) + (additionallyColumn.length + 2) * 34

    return (
        <Box sx={{
            width: '100%',
            maxWidth: '100%',
            overflow: 'auto',
        }}>
            <Box
                sx={{display: 'flex', justifyContent: "flex-end", paddingBottom: "30px"}}
            >
                {!isPlan && <FormControlLabel
                    control={<Switch checked={shipped} onChange={handleChange} name="shipped"/>}
                    label="Отгружено"
                />
                }
                {!isPlan && <ButtonCreate
                    text={"Планы"}
                    width={80}
                    onClick={redirectPlans}
                    icon={false}
                />}
            </Box>
            <MaterialReactTable
                renderTopToolbar={({table}) => {
                    return <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "7px",
                        backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                    }}>
                        <MRT_ToolbarAlertBanner table={table}/>
                        <Box sx={{display: "flex"}}>
                            <MRT_ToggleFiltersButton table={table}/>
                            <MRT_GlobalFilterTextField table={table}/>
                        </Box>
                    </Box>
                }}
                selectAllMode={"all"}
                muiTableContainerProps={{
                    sx: {
                        width: '100%',
                        minWidth: `${minTableWidth}px`,
                        maxHeight: `calc(100vh - 450px)`
                    }
                }}
                muiTableProps={{
                    sx: {
                        width: '100%',
                    },
                }}
                muiTableBodyCellProps={{
                    sx: {
                        padding: '0px 0px 0px 10px',
                        margin: 0,
                        border: '1px solid #EAEBEA',
                        "&:after": {
                            display: "none",
                        },
                        "& td:after": {
                            "&:hover": {
                                backgroundColor: "red"
                            }
                        },
                        "&:first-of-type": (isIssue || isPlan) && {
                            padding: 0,
                            width: "50px",
                            height: "36px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            color: (theme) => theme.palette.text.light,
                            "& .MuiButtonBase-root": {
                                borderRadius: "4px",
                                width: "24px",
                                height: "24px",
                                opacity: 1,
                                margin: 0,
                                padding: 0,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                }
                            }
                        },

                        [`&:nth-of-type(n+${zeroPaddingFromColumn})`]: {
                            padding: 0,
                        },

                        "& li": {
                            listStyleType: "none",
                            "& a": {
                                color: "#006CCC",
                                textDecoration: "none",
                                "&:hover": {
                                    textDecoration: "underline"
                                }
                            }
                        }
                    },
                }}
                muiTableHeadCellProps={{
                    sx: {
                        border: '1px solid #EAEBEA',
                        backgroundColor: "#F5F6FA",
                        padding: '0px 0px 0px 10px',
                        [`&:nth-of-type(n+${zeroPaddingFromColumn})`]: {
                            padding: 0,
                        },
                        "& .Mui-TableHeadCell-Content": {
                            alignItems: "end",
                            "& .Mui-TableHeadCell-Content-Wrapper": {
                                justifyContent: "center",
                                display: "flex",
                            },
                            "& .Mui-TableHeadCell-Content-Labels": {
                                alignItems: "end",


                                "& span": {
                                    marginBottom: "3px"
                                }
                            }
                        },
                        "& .MuiCollapse-root .MuiSelect-select": {
                            padding: "0 !important",
                            "& .MuiChip-label": {
                                paddingLeft: "5px",
                                paddingRight: "5px",
                            }
                        }
                    },
                }}
                muiTableBodyRowProps={({row}) => {
                    return ({
                        sx: () => ({
                            height: '36px',
                            backgroundColor: "white",
                            "&:hover& td:after": {
                                display: "none",
                            },
                            "&.MuiTableRow-root.Mui-selected": {
                                backgroundColor: (theme) => theme.palette.primary.light70,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light50,
                                },
                            },
                            "&:hover": {
                                "& td:after": {
                                    display: "none",
                                },
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            },
                            '&:nth-of-type(even)': {
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                                backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                },
                            },
                        })
                    })
                }}
                muiSearchTextFieldProps={{
                    placeholder: `Поиск`,
                    sx: {
                        paddingTop: "5px",
                        paddingBottom: "0px",
                        "& .MuiCollapse-root": {
                            borderRadius: '12px',
                            height: 40, width: 290,
                            "& .MuiSvgIcon-root": {
                                color: "#737478"
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: 0
                            }
                        }
                    },
                    variant: 'outlined',
                }}
                displayColumnDefOptions={{
                    'mrt-row-actions': {
                        header: "",
                        size: 3,
                        minSize: 3,
                        grow: false,
                    },
                }}
                enableGrouping
                enableStickyHeader
                enablePinning
                rowHeight={13}
                columnSpacing={0}
                columns={columns}
                data={filteredData}
                initialState={{
                    columnVisibility: {
                        id: false,
                        customerId: false,
                        dateOfPlannedProduction: false
                    },
                    isFullScreen: false,
                    density: "compact",
                    columnPinning: {
                        left: ['mrt-row-actions', 'number'],
                        right: ['packagingPercentage', 'issuePercentage']
                    },
                }}
                onPaginationChange={(updater) => {
                    tableOptionsHandle(updater(tableOptions));
                }}
                onGlobalFilterChange={(value) => {
                    handleSearchQuery(value, data, null)
                }}
                onColumnFiltersChange={(updater) => {
                    handleSearchQuery(updater(columnsFilter), data, null, true)
                }}
                onShowColumnFiltersChange={handleShowColumnFilters}
                state={{
                    showColumnFilters: showColumnFilters,
                    columnFilters: columnsFilter,
                    globalFilter: globalFilter,
                    showGlobalFilter: true,
                    pagination: tableOptions,
                }}
                manualFiltering={true}
                rowCount={tableOptions.totalElements}
                muiToolbarAlertBannerChipProps={{color: 'primary'}}
                localization={MRT_Localization_RU}
                enableRowActions={isIssue || isPlan}
                enableToolbarInternalActions={false}
                getRowId={(originalRow) => originalRow.id}
                renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                    return <MenuItem
                        key={el.type}
                        onClick={() => {
                            el.handler(row.original)
                            closeMenu();
                        }}
                        sx={{
                            margin: "0 8px",
                            borderRadius: "4px",
                            "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                        }}
                    >
                        {el.text}
                    </MenuItem>
                })}
            />
        </Box>
    );
};

export default OrderProductionTable;